import { Suspense } from 'react';
import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { SkeletonListPage } from '@/ui';
import styles from './RouteFallback.module.css';

/**
 * Suspense boundary for the lazily-loaded domain screens.
 *
 * It sits inside the shell, so the sidebar and header stay put while a chunk
 * loads — only the content area shows a placeholder, which reads as loading
 * rather than as the app flickering.
 *
 * The placeholder is the SHAPE of the page that is coming. One generic
 * placeholder for every route meant a dashboard of cards and a two-column
 * detail view both showed a header, four KPI cards and a table, and the real
 * page then replaced it with something else entirely. `withSkeleton` gives a
 * route its own; the bare boundary below keeps the generic one for the routes
 * that genuinely are a list page.
 */
export function RouteFallback() {
  return (
    <Suspense fallback={<RouteSkeleton><SkeletonListPage /></RouteSkeleton>}>
      <Outlet />
    </Suspense>
  );
}

/** The padded content area a placeholder sits in. */
export function RouteSkeleton({ children }: { children: ReactNode }) {
  return <div className={styles.fallback}>{children}</div>;
}
